<div class="item-wrapper" [class.visible]="isChildVisible()" [style.display]="isChildVisible() ? 'flex' : 'none'">
  <div class="item-content" [ngClass]="{ 'no-item-actions': hasMenuHidden() }">
    <ng-container #dynamicContainer></ng-container>
  </div>
  @if (!hasMenuHidden()) {
    <div class="item-actions">
      <button class="ellipsis-button" type="button" (click)="toggleMenu()" [attr.aria-label]="'Item menu'">
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
          <path
            fill="currentColor"
            d="M8 2.5a1.22 1.22 0 0 1 1.25 1.17A1.21 1.21 0 0 1 8 4.84a1.21 1.21 0 0 1-1.25-1.17A1.22 1.22 0 0 1 8 2.5m0 8.66a1.17 1.17 0 1 1-1.25 1.17A1.21 1.21 0 0 1 8 11.16m0-4.33a1.17 1.17 0 1 1 0 2.34a1.17 1.17 0 1 1 0-2.34" />
        </svg>
      </button>
      <lfe-item-menu
        [isVisible]="showMenu()"
        [canDeleteComment]="isCommentCreatedInCurrentSession() || isCommentOwnedByCurrentUser()"
        [itemInputColorControlEnabled]="isItemInputColorControlEnabled()"
        [itemSelectionColorControlEnabled]="isItemSelectionColorControlEnabled()"
        [itemInputColor]="itemInputColor()"
        [itemSelectionColor]="itemSelectionColor()"
        [debug]="debug()"
        (menuAction)="onMenuAction($event)"
        (menuClose)="closeMenu()" />
    </div>
  }
</div>
